import React, { useEffect } from 'react';
import { Card, Dialog, Slide} from '@mui/material/';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function ModalConElementosHijo({open, closeModal, disableBackdropClick, disableEscapeKeyDown,  children}) {
    let buttonYes = React.createRef();

    useEffect(() => {
        if (buttonYes.current!==null)
            buttonYes.current.focus();
    });

    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={()=>closeModal(false)}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disablebackdropclick={disableBackdropClick}
                disableEscapeKeyDown={disableEscapeKeyDown}
            >
                <Card>
                    {children}
                </Card>
            </Dialog>
        </div>
    );
}

ModalConElementosHijo.defaultProps = {
    disableBackdropClick: "true",
    disableEscapeKeyDown: true
};

export default ModalConElementosHijo;